<template>
<div>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h2 class="card-title d-flex">{{$t('CREDITORS.HEADER.TITEL')}}
          <div class="ml-auto text-right">
            <vs-button  @click="LoadData()" size="small" color="primary" type="filled" icon="refresh"></vs-button>
          </div>
        </h2>
        <p class="card-subtitle">
          <span>{{$t('CREDITORS.HEADER.TEXT')}}</span>
        </p>
        <AddCreditorDlg ref="addCreditorDlg" v-on:Accepted="AddCreditorAccepted"></AddCreditorDlg>
        <AddCreditorArticleDlg  ref="addCreditorArticleDlg"  v-on:Accepted="AddCreditorArticleAccepted"></AddCreditorArticleDlg>
      </vs-card>
    </vs-col>
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card >

        <vs-tabs v-model="activeTab">
          <vs-tab :label="$t('CREDITORS.CREDITORS')" >
            <div class="d-flex align-items-center">
              <vs-button class="mt-3 mb-2"  type="filled" icon="add" @click="$refs.addCreditorDlg.showDlg()">{{$t('CREDITORS.ADD')}}</vs-button>
            </div> 
            <div id="creditors_table" class="vs-con-loading__container" >
              <vs-table
                search
                :data="creditors"
                :noDataText="$t('CREDITORS.NO_DATA')"
                stripe
                max-items="25" 
                pagination
                hoverFlat>

                <template slot="header">
                  <h3>
                    {{$t('CREDITORS.TABLE.HEADER')}}
                  </h3>
                </template>
                <template slot="thead">             
                  <vs-th sort-key="creditor.name">
                    {{$t('CREDITORS.TABLE.COL1')}}
                  </vs-th>
                  <vs-th sort-key="creditor.creditor_nr">
                    {{$t('CREDITORS.TABLE.COL2')}}
                  </vs-th>                  
                  <vs-th sort-key="creditor.email">
                    {{$t('CREDITORS.TABLE.COL3')}}
                  </vs-th>
                  <vs-th sort-key="creditor.tel">
                    {{$t('CREDITORS.TABLE.COL4')}}
                  </vs-th>
                  <vs-th sort-key="creditor.address.street1">
                    {{$t('CREDITORS.TABLE.COL5')}}
                  </vs-th>                   
                  <vs-th sort-key="creditor.lastname_contact">
                    {{$t('CREDITORS.TABLE.COL6')}}
                  </vs-th>           
                  <vs-th sort-key="creditor.registered">
                    {{$t('CREDITORS.TABLE.COL7')}}
                  </vs-th>                   
                  <vs-th></vs-th>                                                                                                                                             
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" >                    
                    <vs-td :data="tr.lastname">
                      {{tr.name}}
                    </vs-td>  
                    <vs-td :data="tr.creditor_nr">
                      {{tr.creditor_nr}}
                    </vs-td>                     
                    <vs-td :data="tr.email">
                      {{tr.email}}<span v-if="IsNotNull(tr.email2)"><br/>{{tr.email2}}</span>
                    </vs-td> 
                    <vs-td :data="tr.tel">
                      {{$t('CREDITORS.TABLE.TEL')}}{{tr.tel}}
                    </vs-td>                    
                    <vs-td :data="tr.rech_adr">
                      {{tr.address.street1}}<br v-if="IsTextEmpty(tr.address.street2) == false"/>
                      {{IsTextEmpty(tr.address.street2) == false ? tr.address.street2 : '' }}<br/>
                      {{tr.address.plz + ' ' + tr.address.city}}<br/>
                      {{GetNameOfCountry(tr.address.country_fk)}}
                    </vs-td>   
                    <vs-td :data="tr.lastname_contact">
                      {{tr.lastname_contact}}
                    </vs-td>                      
                    <vs-td :data="tr.registered">
                      <vs-chip > {{DateToString(tr.registered)}} </vs-chip>
                    </vs-td>                         
                    <vs-td>
                      <ButtonList :key="tr.id" :buttonArray="[
                                       {label:$t('CREDITORS.BTN.EDIT'),color:'primary',type:'filled',icon:'edit',show:true,disabled:false,data:[tr]},
                                       {label:$t('CREDITORS.BTN.TO_ARTICLE'),color:'primary',type:'filled',icon:'house',show:true,disabled:false,data:[tr.id,tr.article]},
                                       {label:$t('CREDITORS.BTN.DELETE'),color:'primary',type:'filled',icon:'delete',show:true,disabled:false,data:[tr.id,tr.name]},
                                      ]" v-on:BtnClicked="ButtonListClicked"></ButtonList>
                    </vs-td>                    
                                                                                                                                                                                              
                  </vs-tr>
                </template>
              </vs-table>
            </div>    
          </vs-tab>
          <vs-tab :label="$t('CREDITORS.ARTICLES')" :disabled="actCreditor <= 0">
            <div class="d-flex align-items-center" >
              <vs-button class="mt-3 mb-2 mr-2"  type="filled" icon="arrow_back_ios" @click="activeTab = 0" >{{$t('CREDITORS.BACK_OVERVIEW')}}</vs-button>
              <vs-button class="mt-3 mb-2"  type="filled" icon="add" @click="$refs.addCreditorArticleDlg.showDlg(actCreditor)" >{{$t('CREDITORS.ARTICLE.ADD')}}</vs-button>
            </div> 
            <div id="creditors_obj_table123" class="vs-con-loading__container" >
              <vs-table
                search
                :data="articles"
                :noDataText="$t('CREDITORS.ARTICLE.NO_DATA')"
                stripe
                max-items="25" 
                pagination
                hoverFlat>

                <template slot="header">
                  <h3>
                    {{$t('CREDITORS.ARTICLE.TABLE.HEADER')}}
                  </h3>
                </template>
                <template slot="thead">             
                  <vs-th sort-key="name">
                    {{$t('CREDITORS.ARTICLE.TABLE.COL1')}}
                  </vs-th>             
                  <vs-th sort-key="article_nr">
                    {{$t('CREDITORS.ARTICLE.TABLE.COL2')}}
                  </vs-th>
                  <vs-th sort-key="article_nr_external">
                    {{$t('CREDITORS.ARTICLE.TABLE.COL3')}}
                  </vs-th>        
                  <vs-th sort-key="order_nr">
                    {{$t('CREDITORS.ARTICLE.TABLE.COL4')}}
                  </vs-th>  
                  <vs-th></vs-th>    
                  <vs-th></vs-th>                                                                                                                                             
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" >                    
                    <vs-td :data="tr.name">
                      {{tr.name}}
                    </vs-td>                                        
                    <vs-td :data="tr.article_nr">
                      {{tr.article_nr}}
                    </vs-td>    
                    <vs-td :data="tr.article_nr_external">
                      {{tr.article_nr_external}}
                    </vs-td>  
                    <vs-td :data="tr.order_nr">
                      {{tr.order_nr}}
                    </vs-td> 
                    <vs-td>

                      <img style="max-height:50px" v-show="!IsTextEmpty(tr.imgPrev)" v-bind:src="'data:image/jpeg;base64,'+tr.imgPrev" />
                    </vs-td>                                                                                 
                    <vs-td>
                      <vs-button  class="ml-2" size="small" color="primary" type="filled" icon="edit" @click="$refs.addCreditorArticleDlg.InitDlgData(tr,actCreditor,false)" ></vs-button>
                      <vs-button  class="ml-2" size="small" color="primary" type="filled" icon="upload_file" @click="$refs.addCreditorArticleDlg.InitDlgData(tr,actCreditor,true)" ></vs-button>
                      <vs-button @click="OpenConfirmDeleteArticle(tr.id,tr.name)" class="ml-2" size="small" color="primary" type="filled" icon="delete"></vs-button>                        
                    </vs-td>                    
                                                                                                                                                                                              
                  </vs-tr>
                </template>
              </vs-table>
            </div> 
          </vs-tab>
          </vs-tabs>       
        </vs-card>
      </vs-col>
  </vs-row>

</div>
</template>

<script>

import helperMethods from '../helper/staticFuncHelper';
import codeHelper from '../helper/staticCodeHelper';
import ButtonList from './components/ButtonList.vue';
import AddCreditorDlg from './components/dialogs/AddCreditorDlg.vue';
import AddCreditorArticleDlg from './components/dialogs/AddCreditorArticleDlg.vue';

export default {
  name: "Creditors",
  components: {
    ButtonList,
    AddCreditorDlg,
    AddCreditorArticleDlg
  },
    data: function (){
      return {
      creditors:[],
      articles:[],
      actCreditor:0,
      activeTab:0
      };
  },
  created () {
      this.LoadData();
    },
  computed: 
  { 
    getTableData() {
      var data = [];
      if(this.$store.state.creditor.creditors.data != null)
      {
        data = this.$store.state.creditor.creditors.data;
      }
      return data;
    },  
    loadingTableData () {
      var loading = false;
      if(typeof(this.$store.state.creditor.creditors.status) != 'undefined')
        loading = this.$store.state.creditor.creditors.status.loading;
      return loading;
    },
  },
  watch: {
      getTableData(value) {
          this.creditors = value;
      },
      activeTab(value){
        if(value == 0)
        {
          this.actCreditor = 0;
        }
      }
    },
  methods: {    
      ...helperMethods,
      ...codeHelper,
      GetNameOfCreditor(id)
      {
        for (let idx = 0; idx < this.getTableData.length; idx++) {
          if(this.getTableData[idx].id==id)
          {
            return this.getTableData[idx].name;
          }
        }
        return "";
      },
      LoadData: function ()
      {
        if(this.activeTab == 0)
        {
          this.$store.dispatch('creditor/getCreditors',{ root: true },{ root: true }); 
        }
        else
        {
          let nameOfCrd = this.GetNameOfCreditor(this.actCreditor);
          this.$store.dispatch('creditor/getCreditorArticles', this.actCreditor)
          .then(response => {

            this.articles = [];
            response.forEach(element => {
              this.articles.push(element);
            });
        }, 
        error =>{

            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('CREDITORS.ERROR.DELETE').replace("*1*",nameOfCrd) + ' ' +error});  
        });
        }
        
      },
      AddCreditorArticleAccepted()
      {
        this.LoadData();
      },
      AddCreditorAccepted(){
        this.LoadData();
      },
      ShowCreditorArticles(id, articlesFromTable){
        this.actCreditor = id;
        this.activeTab = 2;
        this.articles = [];
        articlesFromTable.forEach(element => {
          this.articles.push(element);
        });
      },
      OpenConfirmDelete(id,bez) {
        this.$vs.dialog({
          type: "confirm",
          color: "primary",
          title: this.$t('COM.SURE.TITEL'),
          acceptText: this.$t('COM.DELETE'),
          cancelText:this.$t('COM.CANCEL'),
          text: this.$t('CREDITORS.QUESTION.DELETE').replace("*1*",bez),
          accept: this.SendDeleteRequest,
          parameters:{"id": id,"bez": bez}
        });
      
      },
      OpenConfirmDeleteArticle(id,bez) {
        this.$vs.dialog({
          type: "confirm",
          color: "primary",
          title: this.$t('COM.SURE.TITEL'),
          acceptText: this.$t('COM.DELETE'),
          cancelText:this.$t('COM.CANCEL'),
          text: this.$t('CREDITORS.ARTICLE.QUESTION.DELETE').replace("*1*",bez),
          accept: this.SendDeleteCreditorArticleRequest,
          parameters:{"id": id,"bez": bez}
        });
      
      },
      SendDeleteRequest: function(parameters)
      {
        this.$store.dispatch('creditor/deleteCreditor', parameters.id)
        .then(response => {
          if(response.success === true)
          {
            this.LoadData();
            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('CREDITORS.SUCCESS.DELETE').replace("*1*",parameters.bez)});  
          }
          else
          {
            var text = this.$t('CREDITORS.WARNING.DELETE').replace("*1*",parameters.bez);
            text = text.replace("*2*",this.$t(response.text));
            this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
          }
        }, 
        error =>{

            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('CREDITORS.ERROR.DELETE').replace("*1*",parameters.bez) + ' ' +error});  
        });
      },
      SendDeleteCreditorArticleRequest: function(parameters)
      {
        this.$store.dispatch('creditor/deleteCreditorArticle', parameters.id)
        .then(response => {
          if(response.success === true)
          {
            this.$store.dispatch('creditorobject/getDebitorObjects',this.actCreditor);
            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('CREDITORS.ARTICLE.SUCCESS.DELETE').replace("*1*",parameters.bez)});  
          }
          else
          {
            var text = this.$t('CREDITORS.ARTICLE.WARNING.DELETE').replace("*1*",parameters.bez);
            text = text.replace("*2*",this.$t(response.text));
            this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
          }
        }, 
        error =>{

            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('CREDITORS.ARTICLE.ERROR.DELETE').replace("*1*",parameters.bez) + ' ' +error});  
        });
      },



      ButtonListClicked(index, data){
        
        switch(index)
        {
          case 0:
            this.$refs.addCreditorDlg.InitDlgData(data[0]);
            break;
          case 1:
            this.ShowCreditorArticles(data[0],data[1]);
            break;
          case 2:
            this.OpenConfirmDelete(data[0],data[1]);
            break; 

                         
        }
        
      }
  }
};

</script>